import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../../Global/Header";
import Sidebar from "./Sidebar";
import Footer from "../../Global/Footer";


const Layout = () => {
  return (
    <>
      <div className="min-h-screen flex flex-col bg-[#f4f8fb]">
        <Header />
        <Sidebar />
        <Outlet /> {/* This is where the child routes render */}
        <Footer />
      </div>
    </>
  );
};

export default Layout;